import { useEffect } from "react";
import { ReactComponent as LogoPastejo } from "../../../assets/svg/logo/logoPastejo.svg";
import { StepByStepV2 } from "../../../components/OnboardingV2/StepByStep/Index";
import { useOnboarding } from "../../../hooks/useOnboarding";
import { ShapeFileV2 } from "../RegisterV2/ShapeFileV2";
import { CreateProfilesV2 } from "../RegisterV2/CreateProfilesV2/Index";
import { CreateAssortmentV2 } from "../RegisterV2/CreateAssortmentV2/Index";
import { CreateFarmsV2 } from "../RegisterV2/CreateFarmsV2/Index";
import { CreateAreasByFarmV2 } from "../RegisterV2/CreateAreasByFarmV2/Index";
import { CreateMicroAreasByFarmV2 } from "../RegisterV2/CreateMicroAreasByFarmV2/Index";
import { Summary } from "../RegisterV2/Summary/Index";
import "./styles.css";


export function OnboardingV2() {
  const { payload, screenComponent, screenNumber, subScreenNumber, userProgress } = useOnboarding();
  const farms = payload?.farms || [];

  useEffect(() => {
    const section = userProgress.find((item) => item.section === screenNumber);
    const screen = section?.screens?.[subScreenNumber];
    document.title = screen?.name ? `Pastejo | ${screen.name}` : "Pastejo | Onboarding";
  }, [screenNumber, subScreenNumber, userProgress]);

  return (
    <section className="onboarding-v2">
      <header className="onboarding-v2__header">
        <LogoPastejo />
      </header>

      <aside className="onboarding-v2__nav">
        <StepByStepV2
          title="Onboarding"
          stepNumber={1}
          subSteps={[
            { name: "Perfis", element: <CreateProfilesV2 /> },
            { name: "ShapeFile", element: <ShapeFileV2 /> },
            { name: "Agropecuária", element: <CreateAssortmentV2 /> },
            { name: "Fazendas", element: <CreateFarmsV2 /> },
          ]}
        />
        {farms.map((farm, index) => (
          <StepByStepV2
            key={farm.uuid || index}
            title={`Fazenda ${index + 1}`}
            subtitle={farm.name || `Fazenda ${index + 1}`}
            stepNumber={index + 2}
            subSteps={[
              { name: "Retiro", element: <CreateAreasByFarmV2 farmId={farm.uuid} /> },
              { name: "Pasto", element: <CreateMicroAreasByFarmV2 farmId={farm.uuid} /> },
            ]}
          />
        ))}
        <StepByStepV2
          key="onboarding-v2-summary"
          title="Resumo"
          stepNumber={farms.length + 2}
          subSteps={[{ name: "Resumo", element: <Summary /> }]}
          lastStepAsSummary
        />
      </aside>

      <section className="onboarding-v2__content">{screenComponent}</section>
    </section>
  );
}
